<bfx-splitter #splitter layout="vertical" [minSizesPx]="[60, 60]" [panelSizes]="amData.initSizes">
  <!-- Top Algo Orders panel in splitter -->
  <ng-template pTemplate>
    <div class="algo-monitor-panel">
      <div class="ladder-layout algo-layout">
        <div
          class="container-fluid blotter_top_interaction_bar"
          #topMenu
          *ngIf="!embeddedTableMode"
        >
          <div class="blotter_titlebar_interaction">
            <div class="blotter_filter_bar_container">
              <!-- simple dropdown for algo filter types-->
              <bfx-algo-state-dropdown [(ngModel)]="stateFilterType"></bfx-algo-state-dropdown>
              <div class="filter-bar-separator"></div>
              <bfx-dropdown-button
                type="secondary"
                emphasis="bold"
                [(ngModel)]="algoFilterType"
                [labels]="algoFilterTypes"
                class="type-dropdown"
                title="Algo type filter"
              ></bfx-dropdown-button>
              <div class="filter-bar-separator"></div>

              <div
                class="bfx-blotter-filter-bar blotter_filter_bar bar-with-temp"
                [blotterInstance]="blotterInstance"
                [extendedTypeId]="extendedTypeId"
              ></div>
            </div>
            <!-- RHS of toolbar with Action Buttons, Quick Search etc-->
            <div class="bfx-blotter-tools-container">
              <button
                type="button"
                class="bfx-button-negative-bold"
                [disabled]="!amData.canCancelAll"
                (click)="cancelAll()"
                title="Cancel all eligible orders"
              >
                <span>{{amData.cancelAllLabel}}</span>
              </button>
              <button
                type="button"
                class="bfx-button-secondary-bold"
                [disabled]="!amData.canPauseAll"
                (click)="pauseAll()"
                title="Pause all eligible orders"
              >
                <span>{{amData.pauseAllLabel}}</span>
              </button>
              <button
                type="button"
                [class]="amData.showHideToggleClass"
                (click)="toggleTradesPanel()"
                title="Show/Hide risk trade blotter for selected orders"
              >
                <i [class]="amData.showHideIconClass"></i>
                <span>{{ amData.showHideLabel }}</span>
              </button>
              <div class="filter-bar-separator"></div>
              <bfx-quick-search
                class="bfx-quick-search"
                [(ngModel)]="searchValue"
                (ngModelChange)="onChangeSearchValue()"
              ></bfx-quick-search>
              <div class="blotter_titlebar_interaction_right">
                <bfx-icon-button
                  size="sm"
                  iconClass="icon_ion_filter_filled"
                  (action)="showFilterManager($event)"
                  title="Filter Manager"
                ></bfx-icon-button>
                <bfx-icon-button
                  size="sm"
                  iconClass="icon_ion_settings_filled"
                  (action)="settingsMenu.toggle($event)"
                  title="Settings"
                ></bfx-icon-button>
              </div>
            </div>
          </div>

          <!-- Moved out of inner div so doesn't pick up a gap-->
          <bfx-blotter-settings-menu #settingsMenu></bfx-blotter-settings-menu>
        </div>

        <div
          class="container-fluid blotter_top_interaction_bar"
          #topMenu
          *ngIf="embeddedTableMode && embeddedTableModeSearchDealtToggle"
        >
          <div class="blotter_titlebar_interaction">
            <div class="blotter_filter_bar_container"></div>
            <div class="bfx-blotter-tools-container">
              <bfx-quick-search
                class="bfx-quick-search"
                [(ngModel)]="searchValue"
                (ngModelChange)="onChangeSearchValue()"
              ></bfx-quick-search>
            </div>
          </div>
        </div>
        <div class="blotter_table_target" #tableTarget>
          <ag-grid-angular
            style="width: 100%; height: 100%"
            rowHeight="22"
            class="ag-bcdfx"
            [columnDefs]="columnDefs"
            [gridOptions]="gridOptions"
            [toolPanelSuppressSideButtons]="true"
            enableColResize
            enableSorting
            multiSortKey="ctrl"
            [frameworkComponents]="frameworkComponents"
            (mousewheel)="onMouseWheel($event)"
            (mousedown)="onMouseDown($event)"
            (mouseup)="onMouseUp($event)"
            (keydown)="onKeyPress($event)"
            (contextmenu)="handleClick($event)"
          >
          </ag-grid-angular>
        </div>
      </div>
    </div>

    <!-- top-level dom-positioned elements-->
    <bfx-algo-monitor-context-menu
      *ngIf="!embeddedTableMode"
      [currentLadderBlotter]="blotterInstance"
      bfxElementOnBody
    ></bfx-algo-monitor-context-menu>
    <bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
    </bfx-blotter-column-selector>
  </ng-template>

  <!-- Bottom Risk Trades panel in splitter -->
  <ng-template pTemplate>
    <!-- Bottom Risk Trades Panel -->
    <bfx-algo-risk-trade-blotter
      #riskTradeBlotter
      class="algo-monitor-panel"
      enableToolbar="false"
      (selectionChanged)="onRiskTradeSelectionChange($event)"
      (vwapChanged)="onRiskTradeVWAPChange($event)"
      [tradeOrderIds]="tradeOrderIds"
    ></bfx-algo-risk-trade-blotter>
  </ng-template>
</bfx-splitter>

<div *ngIf="windowUndocked" class="footer">
  <div class="message" fxLayout="row" [innerHTML]="vwapFooterText"></div>
</div>
